module.exports = __webpack_public_path__ + "static/media/100-feature-img.041bc5a6.png";